import React from "react";
import ImageUploader from "./ImageUploader";
import { FiCheck, FiX, FiPlus } from "react-icons/fi";

export default function ItemForm({
  menu,
  selectedCatId,
  setSelectedCatId,
  itemNameHy,
  setItemNameHy,
  itemNameEn,
  setItemNameEn,
  itemPrice,
  setItemPrice,
  imageUrl,
  setImageUrl,
  itemInfo,
  setItemInfo, // ✅ Նոր prop item info-ի համար
  addItem,
  editingItem,
  editItem,
  cancelItemEdit,
}) {
  return (
    <div style={{ marginBottom: 20 }}>
      <h3>{editingItem ? "Խմբագրել կետը" : "Ավելացնել նոր կետ"}</h3>
      
      <select
        value={selectedCatId}
        onChange={(e) => setSelectedCatId(e.target.value)}
      >
        <option value="">Ընտրել բաժինը</option>
        {menu.map((cat) => (
          <option key={cat.id} value={cat.id}>
            {cat.category}
          </option>
        ))}
      </select>

      <input
        type="text"
        placeholder="Անուն (Հայերեն)"
        value={itemNameHy}
        onChange={(e) => setItemNameHy(e.target.value)}
      />
      <input
        type="text"
        placeholder="Name (English)"
        value={itemNameEn}
        onChange={(e) => setItemNameEn(e.target.value)}
      />
      <input
        type="number"
        placeholder="Գին (AMD)"
        value={itemPrice}
        onChange={(e) => setItemPrice(e.target.value)}
      />
      <ImageUploader
        value={imageUrl}
        onChange={setImageUrl}
        placeholder="Նկար URL"
      />
      {/* New textarea for item info */}
      <textarea
        placeholder="Item Info / Նկարագրություն"
        value={itemInfo}
        onChange={(e) => setItemInfo(e.target.value)}
        style={{ display: "block", width: "100%", marginTop: "8px" }}
      />

      {editingItem ? (
        <>
          <button onClick={editItem} style={{ display: "inline-flex", alignItems: "center", gap: "4px" }}><FiCheck /> Պահպանել</button>
          <button onClick={cancelItemEdit} style={{ marginLeft: "8px", display: "inline-flex", alignItems: "center", gap: "4px" }}>
            <FiX /> Չեղարկել
          </button>
        </>
      ) : (
        <button onClick={addItem} style={{ display: "inline-flex", alignItems: "center", gap: "4px" }}><FiPlus /> Ավելացնել</button>
      )}
    </div>
  );
}
